/// <amd-module name="Repos/Views/CommitHub/Components/CommitActionsTable" />
import * as React from "react";
import * as Resources from "Repos/Views/CommitHub/Resources";
import { ObservableValue } from "VSS/Core/Observable";
import { ScreenBreakpoints } from "VSS/Core/Util/Screen";
import { VssComponent } from "VSS/Platform/Layout";
import { Ago } from "VSSUI/Ago";
import { ITableBreakpoint, ITableColumn, SimpleTableCell, Table } from "VSSUI/Table";
import { Tooltip } from "VSSUI/TooltipEx";
import { AgoFormat } from "VSSUI/Utilities/Date";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { VssPersona } from "VSSUI/VssPersona";
import { CommitRoleItem } from "../Contracts";

export interface ICommitActionsTableProps {
    items: ArrayItemProvider<CommitRoleItem>;
}

const tableBreakpoints: ITableBreakpoint[] = [
    {
        breakpoint: ScreenBreakpoints.xsmall,
        columnWidths: [100, -100, 0]
    },
    {
        breakpoint: ScreenBreakpoints.small,
        columnWidths: [245, 180, -100]
    },
    {
        breakpoint: ScreenBreakpoints.medium,
        columnWidths: [450, 300, -100]
    }
];

export class CommitActionsTable extends VssComponent<ICommitActionsTableProps> {
    private columns = [roleColumn, identityColumn, dateColumn];

    public render() {
        return (
            <Table<CommitRoleItem>
                className="repos-commit-role-table"
                columns={this.columns}
                itemProvider={this.props.items}
                selectableText={true}
                tableBreakpoints={tableBreakpoints}
            />
        );
    }
}

const roleColumn: ITableColumn<CommitRoleItem> = {
    id: "actionColumn",
    renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<CommitRoleItem>, tableItem: CommitRoleItem) => {
        return (
            <SimpleTableCell columnIndex={columnIndex} key={columnIndex} tableColumn={tableColumn}>
                {tableItem.role}
            </SimpleTableCell>
        );
    },
    name: Resources.Action,
    width: new ObservableValue(250)
};

const identityColumn: ITableColumn<CommitRoleItem> = {
    id: "idColumn",
    renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<CommitRoleItem>, tableItem: CommitRoleItem) => {
        return (
            <SimpleTableCell columnIndex={columnIndex} key={columnIndex} tableColumn={tableColumn}>
                <>
                    <VssPersona
                        className="icon-margin"
                        displayName={tableItem.identity.displayName}
                        imageUrl={tableItem.identity.imageUrl}
                        size={"extra-small-plus"}
                    />
                    <Tooltip overflowOnly={true}>
                        <span className="text-ellipsis">{tableItem.identity.displayName}</span>
                    </Tooltip>
                </>
            </SimpleTableCell>
        );
    },
    name: Resources.Identity,
    width: new ObservableValue(250)
};

const dateColumn: ITableColumn<CommitRoleItem> = {
    id: "dateColumn",
    renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<CommitRoleItem>, tableItem: CommitRoleItem) => {
        return (
            <SimpleTableCell columnIndex={columnIndex} key={columnIndex} tableColumn={tableColumn}>
                <Ago date={tableItem.date} format={AgoFormat.Extended} />
            </SimpleTableCell>
        );
    },
    name: Resources.Date,
    width: new ObservableValue(-120)
};
